import { useRegistrationProps } from "@/context/useRegistrationProps";
import { getSiteProps } from "@/utils/siteProps";

const TermsAndConditions = () => {
  const { translation, isApp, hostname } = useRegistrationProps();
  const siteDomain = getSiteProps(hostname)?.domain ?? "";
  return (
    <div className="text-content-secondary text-xs">
      {translation.socialLogin.byClicking}{" "}
      <a
        className="text-state-content-link-bold"
        href={`${isApp ? "/trex/android/en/terms-of-use" : "/info/terms-of-use"}`}
      >
        {translation.socialLogin.termsAndConditions}
      </a>
      ,{" "}
      <a
        className="text-state-content-link-bold"
        href={`${isApp ? "/trex/android/en/privacy-statement" : "/info/privacy"}`}
      >
        {translation.socialLogin.privacyPolicy}
      </a>{" "}
      {translation.socialLogin.termsEndText}{" "}
      {isApp ? (
        siteDomain
      ) : (
        <a className="text-state-content-link-bold" href="/">
          {siteDomain}
        </a>
      )}
      .
    </div>
  );
};

export default TermsAndConditions;
